import { render, staticRenderFns } from "./HowardLeight.vue?vue&type=template&id=a913b9b8&"
import script from "./HowardLeight.vue?vue&type=script&lang=js&"
export * from "./HowardLeight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports